/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateGatewayConfigurationRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GatewayConfigurationResponse } from '../models';
// @ts-ignore
import type { GatewayProcessorCredentials } from '../models';
// @ts-ignore
import type { UpdateGatewayConfigurationRequest } from '../models';
/**
 * GatewayConfigurationsApi - axios parameter creator
 * @export
 */
export const GatewayConfigurationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a payment gateway configuration for a partner
         * @summary Create a gateway configuration
         * @param {string} partnerId 
         * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGatewayConfigurationV1: async (partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('createGatewayConfigurationV1', 'partnerId', partnerId)
            // verify required parameter 'createGatewayConfigurationRequest' is not null or undefined
            assertParamExists('createGatewayConfigurationV1', 'createGatewayConfigurationRequest', createGatewayConfigurationRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGatewayConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific gateway configuration for a partner
         * @summary Get gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationV1: async (partnerId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getGatewayConfigurationV1', 'partnerId', partnerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGatewayConfigurationV1', 'id', id)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{id}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all gateway configurations for a partner
         * @summary Get partner\'s gateway configurations
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationsV1: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getGatewayConfigurationsV1', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
         * @summary Get partner gateway credentials
         * @param {string} partnerId Partner identifier
         * @param {string} [xCorrelationID] Optional correlation ID for request tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerGatewayCredentials: async (partnerId: string, xCorrelationID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('getPartnerGatewayCredentials', 'partnerId', partnerId)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-credentials`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xCorrelationID != null) {
                localVarHeaderParameter['X-Correlation-ID'] = String(xCorrelationID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a gateway configuration for a partner
         * @summary Update gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {UpdateGatewayConfigurationRequest} updateGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGatewayConfigurationV1: async (partnerId: string, id: string, updateGatewayConfigurationRequest: UpdateGatewayConfigurationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('updateGatewayConfigurationV1', 'partnerId', partnerId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateGatewayConfigurationV1', 'id', id)
            // verify required parameter 'updateGatewayConfigurationRequest' is not null or undefined
            assertParamExists('updateGatewayConfigurationV1', 'updateGatewayConfigurationRequest', updateGatewayConfigurationRequest)
            const localVarPath = `/api/v1/partners/{partnerId}/gateway-configurations/{id}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGatewayConfigurationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GatewayConfigurationsApi - functional programming interface
 * @export
 */
export const GatewayConfigurationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GatewayConfigurationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a payment gateway configuration for a partner
         * @summary Create a gateway configuration
         * @param {string} partnerId 
         * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGatewayConfigurationV1(partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGatewayConfigurationV1(partnerId, createGatewayConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.createGatewayConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific gateway configuration for a partner
         * @summary Get gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGatewayConfigurationV1(partnerId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.getGatewayConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all gateway configurations for a partner
         * @summary Get partner\'s gateway configurations
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGatewayConfigurationsV1(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GatewayConfigurationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGatewayConfigurationsV1(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.getGatewayConfigurationsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
         * @summary Get partner gateway credentials
         * @param {string} partnerId Partner identifier
         * @param {string} [xCorrelationID] Optional correlation ID for request tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerGatewayCredentials(partnerId: string, xCorrelationID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayProcessorCredentials>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerGatewayCredentials(partnerId, xCorrelationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.getPartnerGatewayCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a gateway configuration for a partner
         * @summary Update gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {UpdateGatewayConfigurationRequest} updateGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGatewayConfigurationV1(partnerId: string, id: string, updateGatewayConfigurationRequest: UpdateGatewayConfigurationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GatewayConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGatewayConfigurationV1(partnerId, id, updateGatewayConfigurationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GatewayConfigurationsApi.updateGatewayConfigurationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GatewayConfigurationsApi - factory interface
 * @export
 */
export const GatewayConfigurationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GatewayConfigurationsApiFp(configuration)
    return {
        /**
         * Create a payment gateway configuration for a partner
         * @summary Create a gateway configuration
         * @param {string} partnerId 
         * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGatewayConfigurationV1(partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GatewayConfigurationResponse> {
            return localVarFp.createGatewayConfigurationV1(partnerId, createGatewayConfigurationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific gateway configuration for a partner
         * @summary Get gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<GatewayConfigurationResponse> {
            return localVarFp.getGatewayConfigurationV1(partnerId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all gateway configurations for a partner
         * @summary Get partner\'s gateway configurations
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGatewayConfigurationsV1(partnerId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GatewayConfigurationResponse>> {
            return localVarFp.getGatewayConfigurationsV1(partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
         * @summary Get partner gateway credentials
         * @param {string} partnerId Partner identifier
         * @param {string} [xCorrelationID] Optional correlation ID for request tracking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerGatewayCredentials(partnerId: string, xCorrelationID?: string, options?: RawAxiosRequestConfig): AxiosPromise<GatewayProcessorCredentials> {
            return localVarFp.getPartnerGatewayCredentials(partnerId, xCorrelationID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a gateway configuration for a partner
         * @summary Update gateway configuration
         * @param {string} partnerId 
         * @param {string} id 
         * @param {UpdateGatewayConfigurationRequest} updateGatewayConfigurationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGatewayConfigurationV1(partnerId: string, id: string, updateGatewayConfigurationRequest: UpdateGatewayConfigurationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GatewayConfigurationResponse> {
            return localVarFp.updateGatewayConfigurationV1(partnerId, id, updateGatewayConfigurationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GatewayConfigurationsApi - object-oriented interface
 * @export
 * @class GatewayConfigurationsApi
 * @extends {BaseAPI}
 */
export class GatewayConfigurationsApi extends BaseAPI {
    /**
     * Create a payment gateway configuration for a partner
     * @summary Create a gateway configuration
     * @param {string} partnerId 
     * @param {CreateGatewayConfigurationRequest} createGatewayConfigurationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public createGatewayConfigurationV1(partnerId: string, createGatewayConfigurationRequest: CreateGatewayConfigurationRequest, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).createGatewayConfigurationV1(partnerId, createGatewayConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific gateway configuration for a partner
     * @summary Get gateway configuration
     * @param {string} partnerId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public getGatewayConfigurationV1(partnerId: string, id: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).getGatewayConfigurationV1(partnerId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all gateway configurations for a partner
     * @summary Get partner\'s gateway configurations
     * @param {string} partnerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public getGatewayConfigurationsV1(partnerId: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).getGatewayConfigurationsV1(partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve payment gateway credentials for a partner. This endpoint is intended for service-to-service communication and requires OAuth scope service.partner.gateway:read.  The credentials are decrypted and returned in plain text for use by calling services. These credentials should be cached by the calling service with appropriate TTL. 
     * @summary Get partner gateway credentials
     * @param {string} partnerId Partner identifier
     * @param {string} [xCorrelationID] Optional correlation ID for request tracking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public getPartnerGatewayCredentials(partnerId: string, xCorrelationID?: string, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).getPartnerGatewayCredentials(partnerId, xCorrelationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a gateway configuration for a partner
     * @summary Update gateway configuration
     * @param {string} partnerId 
     * @param {string} id 
     * @param {UpdateGatewayConfigurationRequest} updateGatewayConfigurationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GatewayConfigurationsApi
     */
    public updateGatewayConfigurationV1(partnerId: string, id: string, updateGatewayConfigurationRequest: UpdateGatewayConfigurationRequest, options?: RawAxiosRequestConfig) {
        return GatewayConfigurationsApiFp(this.configuration).updateGatewayConfigurationV1(partnerId, id, updateGatewayConfigurationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

